"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COVID_REMOTE_SALES_TOOLS = exports.NEW_CMS_HUB_GATE = exports.BRAZIL_PROMOTION_GATE = void 0;
var BRAZIL_PROMOTION_GATE = 'SelfService:BrazilPricingPromotion';
exports.BRAZIL_PROMOTION_GATE = BRAZIL_PROMOTION_GATE;
var NEW_CMS_HUB_GATE = 'CBX:ShowNewCMSHub';
exports.NEW_CMS_HUB_GATE = NEW_CMS_HUB_GATE;
var COVID_REMOTE_SALES_TOOLS = 'COVIDResponse:RemoteSalesTools';
exports.COVID_REMOTE_SALES_TOOLS = COVID_REMOTE_SALES_TOOLS;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/GateKeys.js
// module id = 608
// module chunks = 5 6